/**
 * @generated SignedSource<<aaf4ae8db342923338830b8338423cb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorTopContent_creatorRootPage$data = {
  readonly CreatorRootTransactions: {
    readonly averageSoldPrice: number | null;
  } | null;
  readonly creatorRootAttributes: {
    readonly topPrimaryL1Material: ReadonlyArray<{
      readonly text: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    }> | null;
    readonly topPrimaryL1Style: ReadonlyArray<{
      readonly text: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    }> | null;
  } | null;
  readonly verticals: ReadonlyArray<VerticalType | null> | null;
  readonly " $fragmentType": "SbSharedCreatorTopContent_creatorRootPage";
};
export type SbSharedCreatorTopContent_creatorRootPage$key = {
  readonly " $data"?: SbSharedCreatorTopContent_creatorRootPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorTopContent_creatorRootPage">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "SeoLink_linkData"
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCreatorTopContent_creatorRootPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verticals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorRootTransactions",
      "kind": "LinkedField",
      "name": "CreatorRootTransactions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "averageSoldPrice",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorRootAttributes",
      "kind": "LinkedField",
      "name": "creatorRootAttributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "topPrimaryL1Style",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "topPrimaryL1Material",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreatorRootPage",
  "abstractKey": null
};
})();

(node as any).hash = "a257cc3dafdef0a45474c305d2dedf6f";

export default node;
